import { Button } from '@mui/material';
import React, { useCallback } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import MessageLayout from '../component/layout/MessageLayout';
import { FEATURE_ONEPORTAL } from '../constants';

const InactivePage: React.FC = () => {
  const navigate = useNavigate();

  const { t } = useTranslation('inactivePage');

  const handleLogout = useCallback(() => {
    navigate('/logout', { replace: true });
  }, [navigate]);

  const registrationUrl = FEATURE_ONEPORTAL ? `${import.meta.env.VITE_REGISTRATION_URL}/redeem/resume` : '/register/code';

  return (
    <MessageLayout
      title={t('accountInactive')}
      text={<Trans t={t} i18nKey={'details'} />}
      actions={
        <>
          <Button
            variant="contained"
            color="primary"
            aria-label={t('register')}
            href={registrationUrl}
            sx={{ paddingX: 2, marginBottom: 1 }}
          >
            {t('register')}
          </Button>
          <Button variant="contained" color="secondary" aria-label={t('logout')} onClick={handleLogout} sx={{ paddingX: 4 }}>
            {t('logout')}
          </Button>
        </>
      }
    />
  );
};

export default InactivePage;
